/**
 * When the plan named an audience in prose (not a population token), pick it
 * if exactly one ready audience name appears in the hint. Ambiguous or short
 * names stay unmatched so we never silently keep a leftover session panel.
 */
export function matchAudienceIdFromHint(
  audiences: Array<{ id: string; name: string }>,
  hint: string,
): string {
  const haystack = hint.trim().toLowerCase()
  if (!haystack) {
    return ''
  }
  const hits = audiences.filter((entry) => {
    const name = entry.name.trim()
    return name.length >= 4 && haystack.includes(name.toLowerCase())
  })
  return hits.length === 1 ? hits[0].id : ''
}
